import { Row, Col, Button, Card, Input, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import FormItem from "antd/es/form/FormItem";
import styles from "./ContactForm.module.scss";
import TextArea from "antd/es/input/TextArea";
import { useTranslation } from "react-i18next";
import { ApiContext } from "../../components/Routing/ApiContext";
import { useContext } from "react";

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
}

export const ContactForm: React.FC = () => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = useForm();
  const api = useContext(ApiContext)?.api; //get URL to backend API via ApiContext/ApiProvider mechanism
  
  function handleSubmitForm(values: FormValues) {
    axios
      .post(`${api}/contact`, values)
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        form.resetFields();
        messageApi.open({
          type: "success",
          content: `${t("contact.successMessage")}`,
          duration: 3,
        });
      });
  }

  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        className={styles.form}
        onFinish={handleSubmitForm}
      >
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <FormItem
              label={t("contact.firstName")}
              name="firstName"
              rules={[
                {
                  required: true,
                  message: `${t("contact.firstNameMessage")}`,
                },
              ]}
            >
              <Input data-testid="firstName" />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem label={t("contact.lastName")} name="lastName">
              <Input />
            </FormItem>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <FormItem
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: `${t("contact.emailValidMessage")}`,
                },
                {
                  required: true,
                  message: `${t("contact.emailMessage")}`,
                },
              ]}
            >
              <Input data-testid="email" />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem label={t("contact.phoneNumber")} name="phone">
              <Input />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <FormItem
              label={t("contact.message")}
              name="message"
              rules={[
                {
                  required: true,
                  message: `${t("contact.requiredMessage")}`,
                },
              ]}
            >
              <TextArea data-testid="message" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          {contextHolder}

          <Button htmlType="submit" className={styles.submitButton}>
            {t("buttons.message")}
          </Button>
        </Row>
      </Form>
    </Card>
  );
}
